const rangeSlider = require('rangeslider-pure');

(function () {
    const prices = {
        es: { //spain
            basicPrice: 39.9,
            perAdditionalEmployee: 10,
            currency: '€'
        },
        mx: { //mexico
            basicPrice: 929.9,
            perAdditionalEmployee: 116.9,
            currency: 'MEX'
        },
        cl: { //chile
            basicPrice: 36999.9,
            perAdditionalEmployee: 4599.9,
            currency: 'CLP'
        },
        co: { //colombia
            basicPrice: 176999.9,
            perAdditionalEmployee: 22199.9,
            currency: 'COP'
        },
        ar: { //argentina
            basicPrice: 4799.9,
            perAdditionalEmployee: 599.9,
            currency: 'ARS'
        },
    };

    const SHOW_PRICING_MODAL = 'show-pricing-modal';

    const modal = document.getElementById('tariffs-modal');
    const form = document.getElementById('tariffs-modal-form');
    const errorContainer = modal.querySelector('.error-msg');
    const priceValueContainer = document.querySelector('#basic_price_box .price-number');

    const docfavUrl = document.getElementById('docfavUrl').dataset.docfavUrl;
    const apiUrl = docfavUrl + '/api-backend';

    const defaultStaffNumber = 1;
    let planToggleChecked;
    let staffNumber = defaultStaffNumber;

    form.onsubmit = (event) => {
        event.preventDefault();
        event.stopPropagation();

        const formData = new FormData(event.target);
        const reqBody = {};

        for (const pair of formData.entries())
            reqBody[pair[0]] = pair[1];

        $.post(apiUrl + '/v1/es_ES/leads/pricing', reqBody, res => {
            updatePrice();
            closeModal();
        })
        .fail(err => {
            errorContainer.innerHTML = err?.responseJSON?.messages || err.statusText;
            console.error(err);
        })
    };

    function init() {
        const rangeBox = document.querySelector('#staff_range');
        const staffRange = document.querySelector('#staff_range');
        const staffNumberInput = document.querySelector('#staff_number');
        const planToggle = document.querySelector('.plan-toggle-check');
        let rangeBoxPastPos = 0.03;

        if (staffRange) {
            rangeSlider.create(rangeBox, {
                onSlide: (value, pos) => {
                    const currentPos = pos === 0 ? 0 : parseFloat(pos.toFixed(1));
                    const inputValue = +staffNumberInput.value;

                    if (!!inputValue) {
                        if (rangeBoxPastPos < currentPos) {
                            staffNumberInput.value = (Math.max(inputValue, value))
                        } else if (rangeBoxPastPos < currentPos) {
                            staffNumberInput.value = (Math.min(inputValue, value))
                        } else {
                            staffNumberInput.value = (value)
                        }

                        staffNumber = +staffNumberInput.value;

                        updatePrice();
                    }

                    if (rangeBoxPastPos !== currentPos) {
                        rangeBoxPastPos = currentPos;
                    }

                }
            })
        }

        if (staffNumberInput) {
            staffNumberInput.oninput = event => {
                let num = event.target.value;

                if (isNaN(parseInt(num))) {
                    if (num > 30) {
                        num = 30;
                    } else {
                        num = defaultStaffNumber;
                    }
                }

                rangeBox.rangeSlider.update({
                    value: parseInt(num)
                }, true);
            };

            staffNumberInput.onblur = (event) => {
                let num = event.target.value;

                if (isNaN(parseInt(num))) {
                    staffNumberInput.value = defaultStaffNumber;
                    rangeBox.rangeSlider.update({
                        value: defaultStaffNumber
                    }, true)
                }
            };
        }

        if (planToggle) {
            planToggleChecked = planToggle.checked;

            planToggle.onchange = event => {
                planToggleChecked = event.target.checked;
                updatePrice();
            }
        }

    }

    function updatePrice() {
        const COUNTRY = 'country';
        const queryParams = {};

        new URLSearchParams(window.location.search).forEach((value, key) => queryParams[key] = value);

        const country = queryParams[COUNTRY] || sessionStorage.getItem(COUNTRY);

        localStorage.setItem(SHOW_PRICING_MODAL, 'false');

        const values = prices[(country || 'es')];
        const price = ((values.basicPrice + (values.perAdditionalEmployee * (staffNumber - 1))) * 10 / (planToggleChecked ? 12 : 10))
            .toFixed(2)
            .replace('.', ',');

        if (country === 'mx' || country === 'cl') {
            priceValueContainer.innerHTML = price + ' <small>' + values.currency + '</small>';
        } else {
            const value = price.split(',');
            priceValueContainer.innerHTML = value[0] + ',<small>' + value[1] + ' ' + values.currency + '</small>';
        }

    }

    function initModal() {
        const shouldShowPricingModal = localStorage.getItem(SHOW_PRICING_MODAL);

        if (shouldShowPricingModal === 'false') {
            updatePrice();
            closeModal();
        }
    }

    function closeModal() {
        modal.parentNode.removeChild(modal);
    }

    init();
    initModal();

})();
